/* eslint @typescript-eslint/no-explicit-any: ['off'] -- "any" types are intentional */
import { reach, Schema } from 'yup'

import { isDebugEnv } from '~config/envConfig'

/**
 *  reach into a yup schema and resolve a single validation
 */
export const isFormFieldRequiredBySchema = (fieldName: string, schema: Schema<any>, formValues?: any, context?: any): boolean => {
  try {
    const fieldValidationSchema = schema
      ? reach(schema, fieldName, formValues, context)
      : false
    const resolvedSchema = fieldValidationSchema
      // @ts-ignore - todo - remove the ts-ignore as soon as the types include the resolve function
      // as of @types/yup": "0.26.26" - ".resolve" is not yet in the type definitions
      // .resolve exists for every schema
      ? fieldValidationSchema.resolve({ value: formValues })
      : false
    const tests = resolvedSchema ? resolvedSchema.describe().tests : false
    return tests ? !!tests.find((test: any) => test.name === 'required') : false
  } catch (e) {
    if (isDebugEnv) {
      console.groupCollapsed('error in isFormFieldRequiredBySchema')
      console.log('fieldName: ', fieldName)
      console.log('schema: ', schema)
      console.log('formValues: ', formValues)
      console.log('error: ', e)
      console.groupEnd()
    }
  }
  return false
}
